import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    const r = await register(name, email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Account created.");
      nav("/", { replace: true });
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div data-testid="register-page" className="min-h-[80vh] grid lg:grid-cols-2">
      <section className="flex items-center justify-center p-6 md:p-12 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md border-[3px] border-black bg-white p-8 shadow-brut space-y-4">
          <div className="font-mono-ui text-xs text-[#00d4ff]">— JOIN UKPR</div>
          <h1 className="font-display text-4xl leading-none">Create account.</h1>

          <div>
            <label className="font-mono-ui text-[10px] block mb-1">FULL NAME</label>
            <input required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs" />
          </div>
          <div>
            <label className="font-mono-ui text-[10px] block mb-1">EMAIL</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs" />
          </div>
          <div>
            <label className="font-mono-ui text-[10px] block mb-1">PASSWORD · MIN 6</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs" />
          </div>

          <button type="submit" disabled={loading} data-testid="register-submit" className="w-full py-3 bg-[#00d4ff] text-black border-[3px] border-black shadow-brut btn-press font-mono-ui text-xs font-bold disabled:opacity-60">
            {loading ? "CREATING…" : "CREATE ACCOUNT"}
          </button>

          <div className="font-mono-ui text-[11px] text-black/70 pt-2">
            Already have an account? <Link to="/login" className="underline hover:text-[#ff1493]">Sign in</Link>
          </div>
        </form>
      </section>

      <section className="hidden lg:block bg-black text-white border-l-[3px] border-black relative overflow-hidden order-1 lg:order-2">
        <div className="hex-grid absolute inset-0 opacity-10" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <div className="font-mono-ui text-[11px] text-[#00d4ff]">— WHY REGISTER?</div>
          <div>
            <h2 className="font-display text-5xl leading-none">Track orders.<br /><span className="text-[#ff1493]">Download</span> COAs.<br />Reorder faster.</h2>
          </div>
          <div className="font-mono-ui text-[11px] text-white/60">YOUR DATA IS NEVER SOLD OR SHARED.</div>
        </div>
      </section>
    </div>
  );
}
